import { useEffect } from "react";
import MultiEntityViewAll from "../../../containers/MultiEntities/MultiEntityViewAll";
import { useDispatch } from "react-redux";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

const MultiEntityPopup = ({ isMultiPopupOpen, setIsMultiPopupOpen }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, [dispatch]);
  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen  bg-PopUp-BackDrop/80"
      style={{
        zIndex: "calc(var(--max-zindex) - 10)",
      }}
    >
      <div className="common_popup bg-primary-card animate-none Qmd:animate-slideInFromRight">
        <MultiEntityViewAll
          type={"popup"}
          setIsMultiPopupOpen={setIsMultiPopupOpen}
          isMultiPopupOpen={isMultiPopupOpen}
        />
      </div>
    </div>
  );
};

export default MultiEntityPopup;
